import {
    PDFDownloadLink,
    Document,
    Page,
    View,
    Text,
    BlobProvider,
    StyleSheet,
    Image,
    Font,
}
    from '@react-pdf/renderer';
import { COLORS, staticLevelData, levelcolors } from "../constants"
import Pig from "../assets/images/Pig_Certificate.png"
import Logo from "../assets/images/logo.png"
import Bronze from "../assets/images/Bronze_Rosette_Certificate.png"
import Silver from "../assets/images/Silver_Certificate.png"
import Gold from "../assets/images/Gold_Certificate.png"
import { useEffect } from "react"
const styles = StyleSheet.create({
    page: {
        fontFamily: 'Fredoka One',
        fontSize: 13,
        paddingTop: 30,
        paddingLeft: 60,
        paddingRight: 60,
        lineHeight: 1.5,
        flexDirection: 'column',
        backgroundColor: '#60B6D7'
    },
    pig: {
        width: '170px',
        position: 'absolute',
        bottom: 10,
        left: 10
    },
    rosette: {
        width: '50px',
        position: 'absolute',
        top: 45,
        right: 70
    },
    logo: {
        width: '250px',

        marginTop: 20,
        marginLeft: 237
    },
    section: {
        marginTop: 10
    },
    circle: {
        borderRadius: "50%",
        width: 70,
        height: 70,
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: -35

    },
    whiteCard: {
        backgroundColor: 'white',
        borderRadius: 15,
        marginTop: 20,
        paddingBottom: 20
    },
    line: {
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderColor: '#C4C4C4',
        width: 130,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
});
export default function Certificate({ level, name, date, type }) {
    useEffect(() => {
        console.log(date)
    }, [])
    return (
        <Document>
            <Page style={styles.page} size="A5" orientation="landscape">
                <View style={styles.whiteCard}>
                    {type == 'Bronze' && <Image src={Bronze} style={styles.rosette} />}
                    {type == 'Silver' && <Image src={Silver} style={styles.rosette} />}
                    {type == 'Gold' && <Image src={Gold} style={styles.rosette} />}

                    <View style={{
                        backgroundColor: levelcolors[3].bgColor,
                        borderRadius: "50%",
                        width: 70,
                        height: 70,
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: -35
                    }}>
                        <Text style={{ fontSize: 12, marginTop: 8, color: levelcolors[3].color }}>Level</Text>
                        <Text style={{ fontSize: 30, marginTop: "-7px", color: levelcolors[3].color }}>{level}</Text>
                    </View>
                    <View style={{ textAlign: 'center' }}>
                        <Text style={{ fontSize: 30, marginTop: 10 }}>
                            <Text style={{ color: COLORS.level_one }}>W</Text>
                            <Text style={{ color: COLORS.level_two }}>e</Text>
                            <Text style={{ color: COLORS.level_three }}>l</Text>
                            <Text style={{ color: COLORS.level_four }}>l</Text>

                            <Text style={{ color: COLORS.level_five }}> D</Text>
                            <Text style={{ color: COLORS.level_six }}>o</Text>
                            <Text style={{ color: COLORS.level_one }}>n</Text>
                            <Text style={{ color: COLORS.level_two }}>e</Text>
                            <Text style={{ color: COLORS.level_four }}>!</Text>
                        </Text>
                    </View>
                    <View style={{ textAlign: 'center', textAlign: "center" }}>
                        <Text style={{ marginTop: 25, fontSize: 17 }}>{name}</Text>
                        <View style={styles.line}></View>
                        <View style={{ marginTop: 15, width: "60%", marginLeft: 'auto', marginRight: "auto" }}>
                            <Text style={{ textAlign: "center" }}>You have been awarded a {type} rosette. Keep up the good work.</Text>
                        </View>
                        <Text style={{ marginTop: 40, color: COLORS.level_five }}>{date}</Text>
                    </View>
                </View>
                <Image src={Pig} style={styles.pig} />
                <Image src={Logo} style={styles.logo} />
            </Page>
        </Document>
    );
}